import { render, staticRenderFns } from "./email-editor-templates.vue?vue&type=template&id=9400be92"
import script from "./email-editor-templates.vue?vue&type=script&lang=js"
export * from "./email-editor-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports